import { FormControl, MenuItem, Select, type SelectChangeEvent } from '@mui/material';

import { useSelectLoginState } from 'Auth/data';
import { LoginState } from 'Auth/data/types';
import { supportedLanguages } from 'Consts/language';
import { useAppDispatch } from 'Store';
import { saveLanguage } from 'User/data/async-thunks';
import { useCurrentLanguage } from 'Utils/customHooks';

export const LanguageBar = () => {
  const dispatch = useAppDispatch();

  const currentLanguage = useCurrentLanguage();
  const loginState = useSelectLoginState();

  const onLanguageChange = (event: SelectChangeEvent) => {
    const isLogged = loginState === LoginState.LOGGED;
    dispatch(saveLanguage({ languageCode: event.target.value, isLogged }));
  };

  const menuItems = supportedLanguages.map(language => (
    <MenuItem key={language.code} value={language.code}>
      {language.displayName}
    </MenuItem>
  ));

  return (
    <FormControl size="small">
      <Select value={currentLanguage.code} onChange={onLanguageChange}>
        {menuItems}
      </Select>
    </FormControl>
  );
};
